
type MediaType = {
  type: 'image' | 'video';
  url: string;
};

export interface UseCase {
  title: string;
  description: string;
  media: MediaType;
}

export const useCasesData: UseCase[] = [{
  title: "Colloqui AI che non perdono nessun talento",
  description: "L'approccio skill-based richiederebbe colloqui tecnici per ogni candidato, oggi insostenibile per le aziende. Con Vertigo, un agente AI guidato dal nostro framework proprietario \"Traced-path\" verifica le competenze di ciascun candidato in modo naturale e dinamico. Zero talenti persi, massima efficienza",
  media: {
    type: 'image',
    url: "/lovable-uploads/TailoredRejection.gif"
  }
}, {
  title: "Ingaggia i candidati subito, via Whatsapp",
  description: "Non aspettare che il candidato si scordi di essersi candidato, usa il nostro Agente AI per contattarlo subito via whatsapp. Esegui uno screening preliminare per qualificare i candidati, e rimani a disposizione h24 per qualsiasi domanda. Comunica subito feedback di candidatura",
  media: {
    type: 'image',
    url: "/lovable-uploads/AnalisiCVintelligente.gif"
  }
}, {
  title: "Feedback personalizzato che crea valore per tutti",
  description: "Sfrutta gli agenti AI di Vertigo per generare report di feedback personalizzati, basati sul CV e sull'esito del colloquio. Offri ai tuoi candidati percorsi di upskilling costruiti ad-hoc sulle loro esigenze. Trasforma ogni candidatura in un'opportunità di crescita reciproca",
  media: {
    type: 'image',
    url: "/lovable-uploads/8f9373aa-303c-4c59-8521-f74967708d00.png"
  }
}, {
  title: "Market Benchmark: confronta con il mercato reale",
  description: "Valuta ogni candidato non solo in assoluto, ma rispetto al pool di professionisti che attualmente ricoprono quella posizione. Il nostro sistema analizza competenze, esperienze e soft skills confrontandole con dati di mercato aggiornati. Decisioni più informate, assunzioni più strategiche",
  media: {
    type: 'image',
    url: "/lovable-uploads/49727af2-2b00-4d09-b50b-e202800d1a5a.png"
  }
}, {
  title: "Misurazione dell'impatto dell'AI",
  description: "Costruiamo insieme KPIs personalizzati per misurare l'efficacia del sistema AI nei tuoi processi di recruiting. Traduciamo i KPIs in una dashboard dedicata, dove monitorare l'andamento dei processi di Vertigo. Tutto questo insieme, con il nostro servizio di consulenza iniziale",
  media: {
    type: 'image',
    url: "/lovable-uploads/0173bb3f-7706-4dde-b7c4-65488a0a9333.png"
  }
}];
